module.exports = __webpack_public_path__ + "img/publish.0b727b20.png";